export default {
    //tableName: 'typepackagingcatalog',

    attributes: {

        id: {
            type: 'number',
            required: true,
            unique: true,
            columnName: 'id'
        },
        name: {
            type: 'string',
            required: true,
        },

    },
};


// WEBPACK FOOTER //
// ./src/models/TypePackagingCatalog.js